<div class="mo-container" [formGroup]="formGroup">
  @if (this.setSprinner()) {
  <div class="pias-spinner">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  }
  <!-- Off-boarding is edited section by section: each panel carries its own
       fields and its own Save, so a department's clearance can be recorded
       without waiting on the rest of the form. -->
  <mat-accordion class="mo-accordion">
    @for (section of sections; track section.key; let i = $index) {
    <mat-expansion-panel class="mo-panel" [expanded]="isPanelExpanded(i)" (opened)="onPanelOpened(i)"
      (closed)="onPanelClosed(i)">
      <mat-expansion-panel-header>
        <mat-panel-title class="mo-panel-title">
          <mat-icon>{{ section.icon }}</mat-icon>
          {{ section.title }}
        </mat-panel-title>
        <!-- <mat-panel-description class="mo-panel-desc">
            <span class="mo-panel-desc-text">{{ section.description }}</span>
            @if (isSaved(section.key)) {
              <span class="saved-badge"><mat-icon>check_circle</mat-icon> Saved</span>
            }
          </mat-panel-description> -->
      </mat-expansion-panel-header>

      <div class="mo-panel-body">
        @switch (section.key) {

        <!-- Section 1 — Resignation details -->
        @case ('resignation') {
        <div class="mo-card">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="field-label">Status</label>
              <mat-form-field class="w-100">
                <mat-select formControlName="status">
                  @for (status of statuses; track status.value) {
                  <mat-option [value]="status.value">{{ status.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <label class="field-label">Date of Resigned (PIAS)</label>
              <mat-form-field class="w-100">
                <input matInput formControlName="resignedDatePias" [matDatepicker]="resignedPicker"
                  placeholder="DD/MM/YYYY" required>
                <mat-datepicker-toggle matIconSuffix [for]="resignedPicker"></mat-datepicker-toggle>
                <mat-datepicker #resignedPicker></mat-datepicker>
                @if(this.formGroup.controls["resignedDatePias"].invalid
                && (this.formGroup.controls["resignedDatePias"].touched ||
                this.formGroup.controls["resignedDatePias"].dirty)
                ) {
                <mat-error>
                  @if(this.formGroup.controls["resignedDatePias"].errors?.["required"]) {
                  <span>{{message}}</span>
                  }
                  @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <label class="field-label">Last Day of Service</label>
              <mat-form-field class="w-100">
                <input matInput formControlName="lastDayOfService" [matDatepicker]="lastDayPicker"
                  placeholder="DD/MM/YYYY" required>
                <mat-datepicker-toggle matIconSuffix [for]="lastDayPicker"></mat-datepicker-toggle>
                <mat-datepicker #lastDayPicker></mat-datepicker>
                @if(this.formGroup.controls["lastDayOfService"].invalid
                && (this.formGroup.controls["lastDayOfService"].touched ||
                this.formGroup.controls["lastDayOfService"].dirty)
                ) {
                <mat-error>
                  @if(this.formGroup.controls["lastDayOfService"].errors?.["required"]) {
                  <span>{{message}}</span>
                  }
                  @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <label class="field-label">DSU Charges</label>
              <mat-form-field class="w-100">
                <input matInput type="text" onkeydown="return /^[0-9.]$/.test(event.key) ||
                   ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                   'Tab', 'Home', 'End'].includes(event.key)" formControlName="dsuCharges" placeholder="Enter amount"
                  required>
                @if(this.formGroup.controls["dsuCharges"].invalid
                && (this.formGroup.controls["dsuCharges"].touched ||
                this.formGroup.controls["dsuCharges"].dirty)
                ) {
                <mat-error>
                  @if(this.formGroup.controls["dsuCharges"].errors?.["required"]) {
                  <span>{{message}}</span>
                  }
                  @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-12">
              <label class="field-label">Reason For Leaving</label>
              <mat-form-field class="w-100">
                <textarea matInput formControlName="reasonForLeaving" placeholder="Enter reason for leaving" required>
                    </textarea>
                @if(this.formGroup.controls["reasonForLeaving"].invalid
                && (this.formGroup.controls["reasonForLeaving"].touched ||
                this.formGroup.controls["reasonForLeaving"].dirty)
                ) {
                <mat-error>
                  @if(this.formGroup.controls["reasonForLeaving"].errors?.["required"]) {
                  <span>{{message}}</span>
                  }
                  @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Attachments -->
        <h6 class="mo-subhead"><mat-icon>attach_file</mat-icon> Attachments</h6>
        <div class="mo-card">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="field-label">Attachment of the Email PDF from Manager</label>
              <label class="file-drop">
                <input id="managerEmailAttachment" type="file" hidden accept=".pdf,.jpg,.jpeg,.png"
                  [disabled]="readonly()" (change)="onAttachmentFileChange($event, 'managerEmailAttachment')">
                <mat-icon>upload_file</mat-icon>
                <span class="file-drop-text">{{ fileName('managerEmailAttachment') ? fileName('managerEmailAttachment')
                  : 'Choose a file'}}</span>
                @if (fileName('managerEmailAttachment')) {
                @if(readonly() === false){
                <button type="button" class="file-clear"
                  (click)="removeFile('managerEmailAttachment'); $event.preventDefault()">
                  <mat-icon>close</mat-icon>
                </button>
                }
                <button type="button" class="file-clear"
                  (click)="previewAttachment('managerEmailAttachment'); $event.preventDefault()">
                  <mat-icon>visibility</mat-icon>
                </button>
                }
              </label>
            </div>
            @if(this.formGroup.get('managerEmailAttachment')?.invalid &&
            (this.formGroup.get('managerEmailAttachment')?.touched
            ||
            this.formGroup.get('managerEmailAttachment')?.dirty)){
            <mat-error>
              @if(this.formGroup.get('managerEmailAttachment')?.errors?.["required"]) {
              <span>{{message}}</span>
              }@else if(this.formGroup.get('managerEmailAttachment')?.errors?.['invalidType']){
              <span>Only PDF, JPG, PNG files are allowed.</span>
              }
              @else if(this.formGroup.get('managerEmailAttachment')?.errors?.['maxSize']){
              <span>File size must be less than or equal to 5MB.</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </div>
        </div>
        }

        <!-- Section 2 — Department clearance questionnaire: one block per
                 department, each with a single attachment. Amount / follow-up
                 fields appear only on a Yes. -->
        @case ('clearance') {
        @for (department of departments; track department.title) {
        <h6 class="mo-subhead"><mat-icon>{{ department.icon }}</mat-icon> {{ department.title }}</h6>
        <div class="mo-card">
          @for (question of department.questions; track question.control; let i = $index) {
          <div class="dept-question">
            <p class="question-text">
              <span class="question-no">{{ i + 1 }}.</span>
              {{ question.text }}
            </p>

            <mat-radio-group class="yn-group" [formControlName]="question.control" (change)="onAnswerChange(question)"
              required>
              <mat-radio-button [value]="true">Yes</mat-radio-button>
              <mat-radio-button [value]="false">No</mat-radio-button>
            </mat-radio-group>

            @if (this.formGroup.get(question.control)?.value === true ) {
            <div class="row g-3">
              <div class="col-md-6">
                <label class="field-label">Amount</label>
                <mat-form-field class="w-100">
                  <input matInput type="text" onkeydown="return /^[0-9.]$/.test(event.key) ||
                      ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                     'Tab', 'Home', 'End'].includes(event.key)" [formControlName]="question.amountControl"
                    placeholder="Enter amount">
                  @let amountControl = this.formGroup.get(question.amountControl);
                  @if(amountControl?.invalid && (amountControl?.touched || amountControl?.dirty)) {
                  <mat-error>
                    @if(amountControl?.errors?.['required']) {
                    <span>{{message}}</span>
                    }
                    @else {
                    <span></span>
                    }
                  </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-md-12">
                <label class="field-label">Remarks</label>
                <mat-form-field class="w-100">
                  <textarea matInput rows="2" [formControlName]="question.remarksControl"
                    placeholder="Enter Remarks"></textarea>
                </mat-form-field>
              </div>

              @if (question.actionControl) {
              <div class="col-md-12">
                <label class="field-label">{{ question.actionLabel }}</label>
                <mat-form-field class="w-100">
                  <textarea matInput rows="2" [formControlName]="question.actionControl"
                    placeholder="Advise further actions"></textarea>
                </mat-form-field>
              </div>
              }

            </div>
            }
          </div>
          @let questionControl = this.formGroup.get(question.control);
          @if(questionControl?.invalid && (questionControl?.touched || questionControl?.dirty)) {
          <mat-error>
            @if(questionControl?.errors?.['required']) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
          }
        </div>
        }

        <div class="col-md-6 dept-attachment">
          <label class="field-label">Department Attachment</label>

          <!-- Hidden input shared by "Choose a file" and "Add another file" -->
          <input #deptFile type="file" hidden accept=".pdf,.jpg,.jpeg,.png" [disabled]="readonly()"
            (change)="onAttachmentFileChange($event, 'Department Attachment'); deptFile.value = ''">

          <!-- One row per uploaded document, each with its own remove and preview -->
          @for (doc of departmentDocs; track doc.id) {
          <div class="file-drop">
            <mat-icon>upload_file</mat-icon>
            <span class="file-drop-text">{{ doc.fileName }}</span>
            @if (readonly() === false) {
            <button type="button" class="file-clear" (click)="removeFile('Department Attachment', doc.id)">
              <mat-icon>close</mat-icon>
            </button>
            }
            <button type="button" class="file-clear" (click)="previewAttachment('Department Attachment', doc.id)">
              <mat-icon>visibility</mat-icon>
            </button>
          </div>
          }

          @if (readonly() === false) {
          @if (departmentDocs.length) {
          <!-- At least one file uploaded: offer to add more -->
          <button type="button" class="file-add" (click)="deptFile.click()">
            <mat-icon>add</mat-icon>
            <span>Add another file</span>
          </button>
          } @else {
          <!-- Nothing uploaded yet: show the initial upload box -->
          <div class="file-drop" (click)="deptFile.click()">
            <mat-icon>upload_file</mat-icon>
            <span class="file-drop-text">Choose a file</span>
          </div>
          }
          }
        </div>

           <!-- Validation message for Department Attachment -->
        @if(this.formGroup.get('Department Attachment')?.invalid && (this.formGroup.get('Department Attachment')?.touched
            ||
            this.formGroup.get('Department Attachment')?.dirty)){
        <mat-error>
          @if(this.formGroup.get('Department Attachment')?.errors?.["required"]) {
          <span>{{message}}</span>
          }@else if(this.formGroup.get('Department Attachment')?.errors?.['invalidType']){
          <span>Only PDF, JPG, PNG files are allowed.</span>
          }
          @else if(this.formGroup.get('Department Attachment')?.errors?.['maxSize']){
          <span>File size must be less than or equal to 5MB.</span>
          }
          @else {
          <span></span>
          }
        </mat-error>
        }

        <!-- Exit form — the rep's signed exit paperwork, collected once the
                   departments have cleared. -->
        <h6 class="mo-subhead"><mat-icon>description</mat-icon> Exit Form</h6>
        <div class="mo-card">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="field-label">Exit Form</label>
              <label class="file-drop">
                <input id="exitFormAttachment" type="file" hidden accept=".pdf,.jpg,.jpeg,.png" [disabled]="readonly()"
                  (change)="onAttachmentFileChange($event, 'exitFormAttachment')">
                <mat-icon>upload_file</mat-icon>
                <span class="file-drop-text"> {{ fileName('exitFormAttachment') ? fileName('exitFormAttachment'):
                  'Choose a file' }}</span>
                @if (fileName('exitFormAttachment')) {
                @if(readonly() === false){
                <button type="button" class="file-clear"
                  (click)="removeFile('exitFormAttachment'); $event.preventDefault()">
                  <mat-icon>close</mat-icon>
                </button>
                }
                <button type="button" class="file-clear"
                  (click)="previewAttachment('exitFormAttachment'); $event.preventDefault()">
                  <mat-icon>visibility</mat-icon>
                </button>
                }
              </label>
            </div>
            @if(this.formGroup.get('exitFormAttachment')?.invalid && (this.formGroup.get('exitFormAttachment')?.touched
            ||
            this.formGroup.get('exitFormAttachment')?.dirty)){
            <mat-error>
              @if(this.formGroup.get('exitFormAttachment')?.errors?.["required"]) {
              <span>{{message}}</span>
              }@else if(this.formGroup.get('exitFormAttachment')?.errors?.['invalidType']){
              <span>Only PDF, JPG, PNG files are allowed.</span>
              }
              @else if(this.formGroup.get('exitFormAttachment')?.errors?.['maxSize']){
              <span>File size must be less than or equal to 5MB.</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </div>
        </div>
        }

        <!-- Section 3 — Remarks -->
        @case ('remarks') {

        <!-- Exit form — the rep's signed exit paperwork, collected once the
                   departments have cleared. -->
        <div class="mo-card">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="field-label"><mat-icon>description</mat-icon> Exit Form</label>
              <label class="file-drop">
                <input id="finalexitFormAttachment" type="file" hidden accept=".pdf,.jpg,.jpeg,.png"
                  [disabled]="readonly()" (change)="onAttachmentFileChange($event, 'finalexitFormAttachment')">
                <mat-icon>upload_file</mat-icon>
                <span class="file-drop-text">{{ fileName('finalexitFormAttachment') || 'Choose a file' }}</span>
                @if (fileName('finalexitFormAttachment')) {
                @if(readonly() === false){
                <button type="button" class="file-clear"
                  (click)="removeFile('finalexitFormAttachment'); $event.preventDefault()">
                  <mat-icon>close</mat-icon>
                </button>
                }
                <button type="button" class="file-clear"
                  (click)="previewAttachment('finalexitFormAttachment'); $event.preventDefault()">
                  <mat-icon>visibility</mat-icon>
                </button>
                }
              </label>
            </div>
            @if(this.formGroup.get('finalexitFormAttachment')?.invalid &&
            (this.formGroup.get('finalexitFormAttachment')?.touched
            ||
            this.formGroup.get('finalexitFormAttachment')?.dirty)){
            <mat-error>
              @if(this.formGroup.get('finalexitFormAttachment')?.errors?.["required"]) {
              <span>{{message}}</span>
              }@else if(this.formGroup.get('finalexitFormAttachment')?.errors?.['invalidType']){
              <span>Only PDF, JPG, PNG files are allowed.</span>
              }
              @else if(this.formGroup.get('finalexitFormAttachment')?.errors?.['maxSize']){
              <span>File size must be less than or equal to 5MB.</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </div>
        </div>
        <br>
        <div class="mo-card">
          <div class="row g-3">
            <div class="col-12">
              <label class="field-label">Remarks</label>
              <mat-form-field class="w-100">
                <textarea matInput rows="3" formControlName="remarks"
                  placeholder="Any additional notes about this off-boarding"></textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
        }
        }

        <!-- Panel actions. Every panel but the last offers both: Save records the
               section and stays put, Save & Continue records it and opens the next
               one. The last panel has nothing to continue to. -->
        @if (readonly() === false) {
        <div class="editor-actions">
          @if (isLastSection(i)) {
          <button type="button" class="save-btn" (click)="onSectionSave(i)">
            <span>Save</span>
            <mat-icon>check</mat-icon>
          </button>
          <button type="button" class="save-btn" (click)="triggeremail(i)">
            <span>Submit</span>
            <!-- <mat-icon>arrow_forward</mat-icon> -->
          </button>
          } @else {
          <button type="button" class="save-btn" (click)="onSectionSave(i)">
            <span>Save</span>
            <mat-icon>check</mat-icon>
          </button>
          <button type="button" class="save-btn" (click)="triggeremail(i)">
            <span>{{ i == 0 ? 'Trigger ExitForm Clearance Department' :'Trigger ExitForm Team'}}</span>
            <mat-icon>arrow_forward</mat-icon>
          </button>
          }
        </div>
        }
      </div>
    </mat-expansion-panel>
    }
  </mat-accordion>

</div>